export enum AuthenticationType {
    Standard = 'Standard',
    AzureActiveDirectory = 'AzureActiveDirectory',
    LDAP = 'LDAP',
}